/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_GInputs */

const en_tut_proyek_g = /** @type {(inputs: Tut_Proyek_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past twenty issues a flat list starts to hurt. Projects group them, and saved views spare you from setting the same filters every morning.`)
};

const id_tut_proyek_g = /** @type {(inputs: Tut_Proyek_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah issue lebih dari dua puluh, daftar datar mulai menyulitkan. Proyek mengelompokkannya, dan tampilan tersimpan membuat Anda tidak menyetel filter yang sama setiap pagi.`)
};

/**
* | output |
* | --- |
* | "Past twenty issues a flat list starts to hurt. Projects group them, and saved views spare you from setting the same filters every morning." |
*
* @param {Tut_Proyek_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_g = /** @type {((inputs?: Tut_Proyek_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_g(inputs)
	return en_tut_proyek_g(inputs)
});